import get from 'lodash/get'

export const closeCampaigns = (shouldCloseCb) => {
	const active = get(window, '_omapp.active')
	if (!active) {
		return
	}

	let found = false

	Object.keys(active).forEach(t => {
		if ('inline' !== t && 0 < active[t].length) {
			active[t].forEach(c => {
				if (!shouldCloseCb || shouldCloseCb(c, t)) {
					c.startClose(true)
					found = true
				}
			})
		}
	})

	return found
}

export const setDemo = e => {
	e.detail.Main.defaults.demo = true
	e.detail.Main.defaults.wp = true
}

export const setPreview = e => {
	e.detail.Campaign.preview = true
}

export const enableBgClick = e => {
	e.detail.Campaigns.campaigns.forEach(
		s => s.forEach(c => {
			c.options.bg_close = 1
		})
	)
}

export const maybeMobiilePreview = e => {
	const { Campaign: c } = e.detail

	if (!c.options.mobile) {
		return
	}

	const $campaign = document.getElementById(`om-${c.id}`)
	const id = `om-${c.id}-Preview`
	let $preview = document.getElementById(id)
	const handleClose = event => {
		if ($preview === event.target || $preview.firstChild === event.target) {
			c.startClose(true)
		}
	}

	$campaign.classList.add('MagicMediaQuery-mobile')

	// If there is a wrapper on then removes it before it adds another
	if ($preview) {
		$preview.removeEventListener('click', handleClose)
		$preview.remove()
	}

	$preview = document.createElement('div')
	$preview.id = id
	$preview.innerHTML = '<div class="MobilePreview"></div>'

	c.contain.parentNode.insertBefore($preview, c.contain)

	$preview.classList.add('Preview')
	$preview.querySelector('.MobilePreview').appendChild(c.contain)

	c.preview = $preview
	c.Types.Type.position()

	$preview.addEventListener('click', handleClose)
}

export const maybeEndMobiilePreview = e => {
	const { Campaign: c } = e.detail

	// This ensures the campaign CAN be closed.
	c.preview = null

	if (c.options.mobile) {
		const $preview = document.getElementById(`om-${c.id}-Preview`)
		if ($preview) {
			setTimeout(() => $preview.remove(), 100)
		}
	}
}
